import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { AccountSettingsService } from '../account-settings.service';
import { UserProfileDetails } from '../../../../common/models/user.model';
import { EditIconComponent } from '@kuiper/icons';
import { OverlayLoaderComponent } from '../../../../common/components/overlay-loader/overlay-loader.component';
import { AvatarComponent } from '../../../../../ui-components/lib/avatar/avatar.component';
import { TenantPathPipe } from '../../../../common/pipes/tenant-path/tenant-path.pipe';
import { TenantService } from '../../../../common/services/tenant/tenant.service';
import { EMPLOYEE_ROUTES } from '../../../../common/constants/employee.routing.constants';
import { AuthService } from '../../../../common/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-profile-tab',
  imports: [
    TranslocoPipe,
    AvatarComponent,
    RouterLink,
    OverlayLoaderComponent,
    EditIconComponent,
    TenantPathPipe,
  ],
  templateUrl: './profile-tab.component.html',
  styleUrl: './profile-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileTabComponent implements OnInit {
  readonly EMPLOYEE_ROUTES = EMPLOYEE_ROUTES;

  accountSettingsService = inject(AccountSettingsService);
  tenantService = inject(TenantService);
  authService = inject(AuthService);
  readonly destroyRef = inject(DestroyRef);

  profileDetails = signal<UserProfileDetails>({} as UserProfileDetails);
  isLoading = signal(false);

  ngOnInit(): void {
    this.getProjectDetails();
  }

  getProjectDetails() {
    this.isLoading.set(true);
    this.accountSettingsService
      .getProfileDetails()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(res => {
        this.profileDetails.set(res.data);
        this.authService.centralUser.update(user => {
          if (user) {
            user.image = res.data.image;
          }
          return user;
        });
        this.isLoading.set(false);
      });
  }
}
